<app-filter-header title="Filtrar texto" i18n-title  (apply)="this.apply()" (reset)="this.reset()" (dismiss)="this.dismiss()"></app-filter-header>
<div class="modal-body">
  <div class="row">
    <app-filter-text-edit id="sigles-filter-codi" class="col-sm-3" i18n-label label="Codi" [(value)]="filter.id"></app-filter-text-edit>
    <app-filter-text-edit id="sigles-filter-descripcio" class="col-sm-9" i18n-label label="Descripció" [(value)]="filter.descripcion"></app-filter-text-edit>
  </div>
</div>
